import React from "react";
import { AspectRatio, Banner, Image, Stack, Text } from "@bookingcom/bui-react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { SOUTHWEST_PHOTOS } from "../../../constants";
import { COMPANY_NAME } from "@flights/constants";

// flights_web_southwest
export default function SearchLoadingSouthwest() {
  const i18n = useI18n();
  return (
    <Stack mixin={{ marginBlockEnd: 4 }}>
      <Banner dismissible={false} closeAriaLabel="Close">
        <Stack direction="row">
          <Stack.Item attributes={{ style: { width: 40 } }}>
            <AspectRatio ratio="1:1">
              <Image src={SOUTHWEST_PHOTOS.logo} alt="" />
            </AspectRatio>
          </Stack.Item>
          <Stack.Item grow>
            <Text tagName="h2" variant="strong_1" mixin={{ padding: 0, margin: 0 }}>
              {i18n.trans(t("flights_mdot_sr_loading_southwest_header"))}
            </Text>
            <Text tagName="p" variant="body_1" mixin={{ padding: 0, margin: 0 }}>
              {i18n.trans(
                t("flights_mdot_sr_loading_southwest_subheader", { variables: { b_companyname: COMPANY_NAME } })
              )}
            </Text>
          </Stack.Item>
        </Stack>
      </Banner>
    </Stack>
  );
}
